import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  Radio,
  RadioGroup,
  Typography,
  CircularProgress,
  Alert,
  useMediaQuery,
  Chip,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  InputAdornment,
  Modal,
  Backdrop,
  LinearProgress,
} from "@mui/material";
import { Close as CloseIcon, SquareFoot } from "@mui/icons-material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Loader } from "@googlemaps/js-api-loader";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useParams } from "react-router-dom";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { StylesConfig } from "react-select";
import placesApiKey from "../../components/utils/Google-Places-API-Key";
import dayjs from "dayjs";
import {
  createMoveService,
  getMoveService,
} from "../../redux/action/move-service";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { getCarrierByBusinessName } from "../../redux/action/carrier";
import { createLabourAndPacking } from "../../redux/action/labour-and-packing";
import { Message, Phone } from "@mui/icons-material";
import Header from "../header/Header";
import axios from "axios";
import StepProgress from "../stepsProgress/stepsProgress";
const PLACES_API_KEY = placesApiKey;

interface AddressOption {
  label: string;
  value: any;
}

interface ChooseServiceProps {
  serviceType: "move-service" | "labour-and-packing";
}
const mapsLoader = new Loader({
  apiKey: PLACES_API_KEY,
  version: "weekly",
  libraries: ["places", "geometry"],
});
const autocompleteStyles: StylesConfig<AddressOption, false> = {
  input: (provided) => ({
    ...provided,
    color: "#000000",
    height: "100%",
    borderRadius: "8px",
  }),
  option: (provided) => ({
    ...provided,
    color: "#808080",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#808080",
  }),
};
const ChooseService: React.FC<ChooseServiceProps> = ({ serviceType }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedService, setSelectedService] = useState("");
  const [fromAddress, setFromAddress] = useState<AddressOption | null>(null);
  const [toAddress, setToAddress] = useState<AddressOption | null>(null);
  const [movingDate, setMovingDate] = useState<any>(null);
  const [bedroomCount, setBedroomCount] = useState("");
  const [isBedroomOpen, setIsBedroomOpen] = useState(false);
  const [distance, setDistance] = useState<number | null>(null);
  const [isCalculating, setIsCalculating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [mapsLoaded, setMapsLoaded] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [propertyType, setPropertyType] = useState<
    "home" | "apartment" | "storage" | ""
  >("");
  const { businessName, carrierCanonicalId } = useParams();
  const [carrier, setCarrier] = useState<any>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const lastStep = 1;
  const canonicalId = localStorage.getItem("canonicalId");

  const [carrierLocations, setCarrierLocations] = useState<any>([]);
  const [locationExists, setLocationExists] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [color, setColor] = useState("#4A90E2");
  const [squareFootageModalOpen, setSquareFootageModalOpen] = useState(false);
  useEffect(() => {
    if (businessName) {
      dispatch<any>(getCarrierByBusinessName(businessName))
        .then(unwrapResult)
        .then((res: any) => {
          setCarrier(res);
          setColor(res.color_hex);
          setCarrierLocations(res.locations);
          console.log(res.locations, "LOCATIONS");
        })
        .catch((err: any) => {
          console.error("Failed to fetch carrier data:", err);
        });
    }
  }, [businessName, dispatch]);
  useEffect(() => {
    if (canonicalId) {
      dispatch<any>(getMoveService(canonicalId))
        .then(unwrapResult)
        .then((res: any) => {})
        .catch((err: any) => {
          console.error("Failed to fetch move data:", err);
        });
    }
  }, [canonicalId]);

  useEffect(() => {
    const loadMaps = async () => {
      try {
        await mapsLoader.load();
        setMapsLoaded(true);
      } catch (err) {
        console.error("Error loading Google Maps API:", err);
        setError("Failed to load maps service. Please refresh the page.");
      }
    };

    loadMaps();
  }, []);

  const formatDateTime = (date: any): string => {
    if (!date || !dayjs(date).isValid()) {
      return dayjs().format("YYYY-MM-DD");
    }
    return dayjs(date).format("YYYY-MM-DD");
  };

  const generateMoveOrderNumber = (): string => {
    const letters = Array.from({ length: 2 }, () =>
      String.fromCharCode(65 + Math.floor(Math.random() * 26))
    ).join("");
    const digits = Math.floor(100000 + Math.random() * 900000);
    return `${letters}${digits}`;
  };

  const getDefaultSquareFeet = () => {
    if (propertyType === "home") {
      if (bedroomCount === "Studio") {
        return 657;
      } else if (bedroomCount === "1 Bedroom") {
        return 791;
      } else if (bedroomCount === "2 Bedroom") {
        return 1274;
      } else if (bedroomCount === "3 Bedroom") {
        return 1917;
      } else if (bedroomCount === "4 Bedroom") {
        return 2658;
      } else if (bedroomCount === "5+ Bedroom") {
        return 3514;
      }
    } else if (propertyType === "apartment") {
      if (bedroomCount === "Studio") {
        return 457;
      } else if (bedroomCount === "1 Bedroom") {
        return 735;
      } else if (bedroomCount === "2 Bedroom") {
        return 1097;
      } else if (bedroomCount === "3 Bedroom") {
        return 1336;
      } else if (bedroomCount === "4 Bedroom") {
        return 1800;
      } else if (bedroomCount === "5+ Bedroom") {
        return 3000;
      }
    } else if (propertyType === "storage") {
      return 0;
    }
    return 0;
  };

  const handleNext = async () => {
    if (
      !fromAddress ||
      !toAddress ||
      !movingDate ||
      !bedroomCount ||
      !propertyType
    ) {
      setError("Please fill in all required fields");
      return;
    }
    setIsLoading(true);
    setLoadingMessage("Processing your move request...");
    const formattedDateTime = formatDateTime(movingDate);

    const serviceData = {
      moving_from: fromAddress.label,
      moving_to: toAddress.label,
      moving_date: formattedDateTime,
      number_of_bedrooms: bedroomCount,
      move_order_number: generateMoveOrderNumber(),
      dwelling_type: propertyType,
      carrier_id: carrier?.id,
      phone_number: phoneNumber,
      last_step: lastStep,
      pickup_square_footage:
        squareFootage !== null ? Number(squareFootage) : getDefaultSquareFeet(),
    };
    console.log(serviceData, "PAYLOAD ----->>>>");

    try {
      let res;
      if (serviceType === "move-service") {
        res = await dispatch<any>(createMoveService(serviceData));
        const newRes = unwrapResult(res);
        const newCanonicalId = newRes.canonical_id;
        localStorage.setItem("canonicalId", newCanonicalId);

        const moveService = await dispatch<any>(getMoveService(newCanonicalId));
        const unwrappedMove = unwrapResult(moveService);
        setDistance(unwrappedMove.distance);
      } else {
        res = await dispatch<any>(createLabourAndPacking(serviceData));
      }

      const result = unwrapResult(res);
      const newCanonicalId = result.canonical_id;
      if (propertyType === "home") {
        navigate(
          `/${businessName}/${carrierCanonicalId}/delivery-details/${newCanonicalId}`
        );
      } else if (propertyType === "apartment") {
        navigate(
          `/${businessName}/${carrierCanonicalId}/apartment-info/${newCanonicalId}`
        );
      } else if (propertyType === "storage") {
        navigate(
          `/${businessName}/${carrierCanonicalId}/storage/${newCanonicalId}`
        );
      }
    } catch (err: any) {
      setError(err?.message || "Failed to create service");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (fromAddress !== null) {
      checkIfLocationExists();
    } else {
      setSquareFootage(null);
      setApiError(null);
    }
  }, [fromAddress]);

  const handleFromAddressChange = (value: AddressOption | null) => {
    setFromAddress(value);
    setSquareFootage(null);
    setApiError(null);
  };

  const handleToAddressChange = (value: AddressOption | null) => {
    setToAddress(value);
  };

  const handleBedroomChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    setBedroomCount(value);
    setIsBedroomOpen(false);
    setSelectedService("");
  };

  const toggleBedroomDropdown = () => {
    setIsBedroomOpen((prev) => !prev);
    setSelectedService("bedrooms");
  };

  const handlePropertyTypeChange = (type: "home" | "apartment" | "storage") => {
    setPropertyType(type);
  };

  const handleBack = () => {
    navigate(`/${businessName}/select-service`);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setSelectedService("");
        setIsBedroomOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isStateInLocations = (address: any, locations: any) => {
    const stateFromAddress = address
      .split(",")
      [address.split(",").length - 2].trim();

    return locations.some((location: any) =>
      location.location_name.includes(stateFromAddress)
    );
  };
  const checkIfLocationExists = () => {
    const exists = isStateInLocations(fromAddress?.label, carrierLocations);
    if (exists === true) {
      setLocationExists(true);
      if (fromAddress) {
        fetchSquareFootage(fromAddress.label);
      }
    } else {
      setLocationExists(false);
    }
  };
  useEffect(() => {
    if (fromAddress !== null) {
      checkIfLocationExists();
    }
  }, [fromAddress]);

  const [squareFootage, setSquareFootage] = useState<number | null>(null);
  const [isFetchingSquareFootage, setIsFetchingSquareFootage] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const fetchZipCodeForAddress = async (address: string) => {
    const apiKey = "AIzaSyAk8hBHGztX6M9UX2MdZlRQS3HbdqINzp8";
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address
    )}&key=${apiKey}`;

    try {
      const response = await axios.get(url);
      const results = response.data.results;
      const zipCode = results[0].address_components?.find((component: any) =>
        component.types.includes("postal_code")
      )?.long_name;
      return zipCode ? zipCode.toString() : "";
    } catch (error) {
      console.error("Error fetching ZIP code:", error);
      throw error;
    }
  };
  const formatAddressForAttom = async (address: string) => {
    const zip = await fetchZipCodeForAddress(address);
    const formattedAddress = `${address
      .replace(/,/g, "")
      .replace(/\s+/g, "+")}+${zip}`;
    return formattedAddress;
  };

  const fetchSquareFootage = async (
    address: string
  ): Promise<number | null> => {
    try {
      setIsFetchingSquareFootage(true);
      setApiError(null);
      const formattedAddress = await formatAddressForAttom(address);
      console.log(formattedAddress, "formattedAddress");
      const url = `https://api.gateway.attomdata.com/propertyapi/v1.0.0/property/detail?address=${formattedAddress}`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          apikey: process.env.REACT_APP_ATTOMS_API_KEY,
        },
      });

      const data = response.data;

      if (!data || !data.property || !data.property[0]) {
        setApiError("No property data found for this address");
        return null;
      }

      const property = data.property[0].building;
      if (property.size && property.size.livingsize) {
        const squareFootage = property.size.livingsize;
        if (squareFootage > 3400) {
          setSquareFootageModalOpen(true);
        }
        setSquareFootage(squareFootage);
        return squareFootage;
      }

      setApiError("Square footage information not available for this property");
      return null;
    } catch (error: any) {
      console.error("Error fetching property details:", error);
      // setApiError("Error fetching property details");
      return null;
    } finally {
      setIsFetchingSquareFootage(false);
    }
  };
  return (
    <div ref={containerRef}>
      <Header />
      {isLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
          onClick={() => {
            setIsLoading(true);
          }}
        >
          <Box sx={{ width: "50%" }}>
            <LinearProgress />
            <Typography
              fontSize={16}
              fontWeight={500}
              textAlign="center"
              mt={1}
            >
              {loadingMessage}
            </Typography>
          </Box>
        </Backdrop>
      )}
      <StepProgress currentStep={2} />

      <Container
        sx={{
          width: "100%",
          maxWidth: "900px",
          py: 4,
        }}
      >
        {/* Title */}
        <Box mb={3}>
          <Typography variant="h5" fontWeight={700}>
            Choose Your Service
          </Typography>
          <Typography color="text.secondary" fontSize={14}>
            Tell us about your move so we can provide the best service
          </Typography>
        </Box>

        {/* Main Form Card */}
        <Box
          sx={{
            background: "#fff",
            p: 3,
            border: "2px solid rgba(0,0,0,0.05)",
            borderRadius: "12px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            mb: 3,
          }}
        >
          {/* Moving From */}
          <Box mb={2}>
            <Typography fontSize={14} mb={0.5}>
              📍 Moving from location
            </Typography>
            {!mapsLoaded ? (
              <Typography fontSize={14} color="text.secondary">
                Loading map services...
              </Typography>
            ) : (
              <GooglePlacesAutocomplete
                apiOptions={{ language: "en" }}
                selectProps={{
                  styles: autocompleteStyles,
                  onChange: handleFromAddressChange,
                  value: fromAddress,
                  placeholder: "Enter address",
                }}
              />
            )}
          </Box>

          {/* Moving To */}
          <Box mb={2}>
            <Typography fontSize={14} mb={0.5}>
              🎯 Moving to location
            </Typography>
            {!mapsLoaded ? (
              <Typography fontSize={14} color="text.secondary">
                Loading map services...
              </Typography>
            ) : (
              <GooglePlacesAutocomplete
                apiOptions={{ language: "en" }}
                selectProps={{
                  styles: autocompleteStyles,
                  onChange: handleToAddressChange,
                  value: toAddress,
                  placeholder: "Enter address",
                }}
              />
            )}
          </Box>

          {/* Moving Date */}
          <Box mb={2}>
            <Typography fontSize={14} mb={0.5}>
              📅 Date
            </Typography>
            <TextField
              // fullWidth
              type="date"
              value={movingDate ? movingDate.format("YYYY-MM-DD") : ""}
              onChange={(e) => {
                const d = dayjs(e.target.value);
                if (d.isValid()) setMovingDate(d);
              }}
              inputProps={{ min: dayjs().add(2, "day").format("YYYY-MM-DD") }}
            />
          </Box>

          {/* Bedrooms */}
          <Box mb={2}>
            <Typography fontSize={14} mb={0.5}>
              🛏️ Number of bedrooms
            </Typography>
            <TextField
              select
              fullWidth
              value={bedroomCount}
              onChange={(e) => setBedroomCount(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="">Select bedrooms</option>
              <option value="Studio">Studio</option>
              <option value="1 Bedroom">1 Bedroom</option>
              <option value="2 Bedroom">2 Bedroom</option>
              <option value="3 Bedroom">3 Bedroom</option>
              <option value="4 Bedroom">4 Bedroom</option>
              <option value="5+ Bedroom">5+ Bedroom</option>
            </TextField>
          </Box>

          {/* Phone */}
          <Box mb={1}>
            <Typography fontSize={14} mb={0.5}>
              📞 Phone Number
            </Typography>
            <TextField
              fullWidth
              value={phoneNumber}
              onChange={(e) => {
                const v = e.target.value;
                if (/^\d*$/.test(v) && v.length <= 10) setPhoneNumber(v);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+1</InputAdornment>
                ),
              }}
              placeholder="Enter 10-digit phone number"
            />
          </Box>
        </Box>

        {/* Pickup Details */}
        <Box
          sx={{
            border: "1px solid rgba(0,0,0,0.05)",
            background: `${color}20`,
            p: 3,
            borderRadius: "12px",
            mb: 4,
          }}
        >
          <Typography fontWeight={600} mb={0.5}>
            Pickup Details
          </Typography>
          <Typography fontSize={13} color="text.secondary" mb={2}>
            Select one that applies to your pickup location
          </Typography>

          <Box display="flex" gap={2}>
            {[
              { value: "home", label: "Home", icon: "🏠" },
              { value: "apartment", label: "Apartment", icon: "🏢" },
              { value: "storage", label: "Storage", icon: "📦" },
            ].map((opt) => (
              <Box
                key={opt.value}
                onClick={() => handlePropertyTypeChange(opt.value as any)}
                sx={{
                  flex: 1,
                  cursor: "pointer",
                  p: 2,
                  borderRadius: "10px",
                  border:
                    propertyType === opt.value
                      ? `2px solid ${color}`
                      : "1px solid #d1d5db",
                  backgroundColor: "#fff",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.2,
                  transition: "0.2s",
                  "&:hover": { borderColor: `${color}` },
                }}
              >
                {/* fake checkbox */}
                <Box
                  sx={{
                    height: "18px",
                    width: "18px",
                    borderRadius: "4px",
                    border:
                      propertyType === opt.value
                        ? `2px solid ${color}20`
                        : "2px solid #9ca3af",
                    backgroundColor:
                      propertyType === opt.value ? `${color}` : "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {propertyType === opt.value && (
                    <Typography
                      sx={{ color: "white", fontSize: "13px", lineHeight: 1 }}
                    >
                      ✓
                    </Typography>
                  )}
                </Box>

                {/* icon + label */}
                <Typography fontSize={15}>
                  {opt.icon} {opt.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Footer Buttons */}
        <Box display="flex" justifyContent="space-between">
          <Button
            variant="text"
            onClick={handleBack}
            sx={{ textTransform: "none", fontWeight: 600 }}
          >
            Back
          </Button>

          <Button
            variant="contained"
            onClick={handleNext}
            disabled={
              !fromAddress ||
              !toAddress ||
              !movingDate ||
              !bedroomCount ||
              !propertyType
            }
            sx={{ textTransform: "none", px: 4 }}
          >
            Continue →
          </Button>
        </Box>
      </Container>
    </div>
  );
};

export default ChooseService;
